import { useEffect } from 'react'
import TagManager from 'react-gtm-module'

export function initDataLayer() {
  window.dataLayer = window.dataLayer || []
}

let gtmInitialized = false

export function addGTM() {
  //set this tag in the corresponding env file(s)
  const GTMID = import.meta.env.VITE_GTM_ID
  if (!GTMID || GTMID === '') {
    console.warn('No Google Tag Manager id provided')
    return
  }
  if (gtmInitialized) return

  TagManager.initialize({ gtmId: GTMID })
  gtmInitialized = true
}

export function useGTM() {
  useEffect(() => {
    initDataLayer()
    addGTM()
  }, [])
}
